import styled from 'styled-components';

export const Header = styled.h1<{ color: string; font: string; size: string }>`
  font-family: ${({ font }) => font};
  font-size: ${({ size }) => size};
  color: ${({ color }) => color};
`;
